import { Schema } from "effect";
import { BrowserListResponse } from "@workerstation/shared/observability/browser";
import { TraceListResponse } from "@workerstation/shared/observability/traces";
import { TraceSpanRecord } from "@workerstation/shared/trace-model";
export const ObservationKind = Schema.Literals(["browser", "traces"]);
export type ObservationKind = typeof ObservationKind.Type;
export const ObservationInput = Schema.Struct({
  kind: ObservationKind, workspaceId: Schema.NullOr(Schema.String), stationId: Schema.NullOr(Schema.String),
  collapsed: Schema.Boolean, refreshToken: Schema.Number, live: Schema.Boolean,
  search: Schema.String, level: Schema.Literals(["all", "debug", "info", "warning", "error"]),
  category: Schema.String, sessionId: Schema.String, status: Schema.Literals(["all", "ok", "error"])
});
export type ObservationInput = typeof ObservationInput.Type;
export const ObservationSnapshot = Schema.Struct({
  input: ObservationInput, browser: Schema.NullOr(BrowserListResponse), traces: Schema.NullOr(TraceListResponse),
  details: Schema.Record(Schema.String, Schema.Array(TraceSpanRecord)), expanded: Schema.Array(Schema.String),
  loading: Schema.Boolean, error: Schema.NullOr(Schema.String), clearVersion: Schema.Int, closed: Schema.Boolean
});
export type ObservationSnapshot = typeof ObservationSnapshot.Type;
export const ObservationCommand = Schema.Union([
  Schema.TaggedStruct("Refresh", {}), Schema.TaggedStruct("Clear", {}),
  Schema.TaggedStruct("ToggleTrace", { traceId: Schema.String }),
  Schema.TaggedStruct("CopyTrace", { traceId: Schema.String }), Schema.TaggedStruct("CopyEvent", { eventId: Schema.String }),
  Schema.TaggedStruct("OpenRecording", { sessionId: Schema.String })
]);
export type ObservationCommand = typeof ObservationCommand.Type;
export const observationInputKey = (input: ObservationInput): string => JSON.stringify([
  input.kind, input.workspaceId, input.stationId, input.collapsed, input.refreshToken,
  input.search, input.level, input.category, input.sessionId, input.status
]);
export const emptyObservationInput = (kind: ObservationKind): ObservationInput => ({ kind, workspaceId: null, stationId: null,
  collapsed: true, refreshToken: 0, live: false, search: "", level: "all", category: "", sessionId: "", status: "all" });
export const emptyObservationSnapshot = (kind: ObservationKind): ObservationSnapshot => ({
  input: emptyObservationInput(kind), browser: null, traces: null, details: {}, expanded: [],
  loading: false, error: null, clearVersion: 0, closed: false
});
